import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2022“开放的六月”云端艺术游';

const route: RouteConfig = {
  path: '/chuan-mei-liu-yue',
  name: '/chuan-mei-liu-yue',
  component: () => import('./RouterHolder.vue'),
  redirect: '/chuan-mei-liu-yue/home',
  meta: {
    title: PAGE_TITLE,
    rank: 1,
  },
  children: [
    {
      path: '/chuan-mei-liu-yue/home',
      component: () => import('./subpages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/detail',
      component: () => import('./subpages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/login',
      component: () => import('./subpages/Login.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/upload',
      component: () => import('./subpages/Upload.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 0,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/sampleReels',
      component: () => import('./subpages/SampleReels.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/canvas',
      component: () => import('./subpages/Canvas.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },

    // 二期路由

    {
      path: '/chuan-mei-liu-yue/GuidePage',
      component: () => import('./secondpages/GuidePage.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/show',
      component: () => import('./subpages/Show.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/ShowCollege',
      component: () => import('./subpages/ShowCollege.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/ShowCollegeDetail',
      component: () => import('./subpages/ShowCollegeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/CollegeList',
      component: () => import('./secondpages/CollegeList.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
        customWeChatAuth: false,
      },
    },
    {
      name: 'CollegeWork',
      path: '/chuan-mei-liu-yue/CollegeWork',
      component: () => import('./secondpages/CollegeWork.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },
    {
      name: 'WorkDetail',
      path: '/chuan-mei-liu-yue/WorkDetail',
      component: () => import('./secondpages/WorkDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/news-list',
      component: () => import('./secondpages/NewsPage.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/CollegeDetail',
      component: () => import('./secondpages/CollegeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },
    {
      path: '/chuan-mei-liu-yue/CollegeDetail',
      component: () => import('./secondpages/CollegeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
        customWeChatAuth: false,
      },
    },
    // 分享页面
    {
      path: '/chuan-mei-liu-yue/SharePage',
      component: () => import('./secondpages/SharePage.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 4,
        customWeChatAuth: false,
      },
    },
    // {
    //   path: '/chuan-mei-liu-yue/Index',
    //   component: () => import('./subpages/Index1.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 2,
    //     customWeChatAuth: false,
    //   },
    // },
  ],
};

export default route;
